<ul
  class="qq-upload-list-selector qq-upload-list"
  aria-live="polite"
  aria-relevant="removals"
>
  @for (document of documents; track document) {
  <li class="qq-upload-success">
    <span>
      <span aria-hidden="true" class="bi bi-file-earmark-fill"></span>
      <span class="qq-upload-file-selector qq-upload-file">
        {{ document.name }}
      </span>
    </span>
    <button
      (click)="remove(document)"
      type="button"
      class="qq-btn qq-upload-delete-selector qq-upload-delete"
    >
      <span aria-hidden="true" class="bi bi-x"></span>
    </button>
  </li>
  }
</ul>
